export const selectActiveTab = (state) => state.settings.activeTab;
export const selectAcronymIgnore = (state) => state.settings.acronymIgnore;
export const selectDiscoveryIgnore = (state) => state.settings.discoveryIgnore;
export const selectReadabilityIgnore = (state) =>
  state.settings.readabilityIgnore;
export const selectThresholds = (state) => state.settings.thresholds;
